


































import Vue from 'vue'
import { Location } from '@/models'
import { trackGaEvent } from '@/util/helper'
import IconAddMember from '@/assets/pmd/img/launchpad/icon-add-member.svg'
import AddUsersModal from './AddUsersModal.vue'

export default Vue.extend({
  props: ['currentLocationId', 'userid'],
  components: {
    AddUsersModal,
    IconAddMember
  },
  data() {
    return {
      addUsersModal: false,
    }
  },
  mounted() {
    this.$root.$on('close-modal', () => {
      this.addUsersModal = false
    })
  },
})
